import {
  TrueFalseQuestionSession,
  OpenWriteQuestionSession,
  MultipleQuestionSession,
  LinkerQuestionSession,
  CategoryQuestionSession,
  FillInQuestionSession,
  OrderedQuestionSession,
  ProcedureQuestionSession
} from './question-session';
import { HttpClient } from '@angular/common/http';
import { StuplayConfig } from "../../../stuplay-config";

export function questionSessionFactory(type: string, questionSession: any, http: HttpClient, stuplayConfig: StuplayConfig) {
    switch (type) {
      case 'true-false' : {
        return new TrueFalseQuestionSession(questionSession, http, stuplayConfig);
      }
      case 'open-write' : {
        return new OpenWriteQuestionSession(questionSession, http, stuplayConfig);
      }
      case 'multiple' : {
        return new MultipleQuestionSession(questionSession, http, stuplayConfig);
      }
      case 'linker' : {
        return new LinkerQuestionSession(questionSession, http, stuplayConfig);
      }
      case 'category' : {
        return new CategoryQuestionSession(questionSession, http, stuplayConfig);
      }
      case 'fill-in' : {
        return new FillInQuestionSession(questionSession, http, stuplayConfig);
      }
      case 'ordered' : {
        return new OrderedQuestionSession(questionSession, http, stuplayConfig);
      }
      case 'procedure' : {
        return new ProcedureQuestionSession(questionSession, http, stuplayConfig);
      }

    }
}
